import React from "react";
import { useBarcode } from "next-barcode";

function GenerateBarcode({ isbn }) {
	const { inputRef } = useBarcode({
		value: `${isbn}`,
		options: {
			background: "#FFFFFF",
		},
	});

	return <svg ref={inputRef} />;
}

export default GenerateBarcode;
